import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative pb-12" }
const _hoisted_2 = { class: "sticky top-32 z-20" }
const _hoisted_3 = { class: "-ml-8" }
const _hoisted_4 = { class: "h-12" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  colspan: "2"
}

import { getTechnologyCategoryLabelForTechnologyType, getTechnologyTypeLabel, Product, ProductTechnology, Technology, TechnologyCategory, TechnologyType, technologyTypesByCategory } from "@/model";
import { CheckCircleIcon } from '@heroicons/vue/20/solid';

import Dialog from '@/components/Dialog.vue'
import { pb } from "@/pocketbase";
import { computed, reactive, ref } from "vue";
import Input from "@/components/Input.vue";
import Button from "@/components/Button.vue";
import Success from "@/components/Success.vue";
import Heading from "@/components/Heading.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'EditProductDialog',
  props: {
    product: {}
  },
  async setup(__props: any) {

let __temp: any, __restore: any

const props = __props

const searchTerm = ref('');

const technologies: Technology[] = (
  ([__temp,__restore] = _withAsyncContext(() => pb.collection('technologies').getFullList<Technology>(null, {
  sort: 'type,name',
}))),
  __temp = await __temp,
  __restore(),
  __temp
);

const groupedTechnologies = computed(
    () => {
      const groups: Record<string, {
        category: TechnologyCategory,
        types: Record<string, {
          type: TechnologyType,
          technologies: Technology[],
        }>,
      }> = {};

      for (const { category, types } of technologyTypesByCategory) {
        for (const type of types) {
          for (const technology of technologies) {
            if (technology.name.toLowerCase().indexOf(searchTerm.value.toLowerCase()) === -1) {
              continue;
            }

            const technologyTypeLabel = getTechnologyTypeLabel(technology.type);
            if (technologyTypeLabel !== type) {
              continue;
            }

            const technologyCategoryLabel = getTechnologyCategoryLabelForTechnologyType(technology.type);
            if (technologyCategoryLabel !== category) {
              continue;
            }

            if (!groups[technologyCategoryLabel]) {
              groups[technologyCategoryLabel] = {
                category: technologyCategoryLabel,
                types: [],
              }
            }

            if (!groups[technologyCategoryLabel].types[technologyTypeLabel]) {
              groups[technologyCategoryLabel].types[technologyTypeLabel] = {
                type: technologyTypeLabel,
                technologies: [],
              }
            }

            groups[technologyCategoryLabel].types[technologyTypeLabel].technologies.push(technology);
          }
        }
      }

      return groups;
    },
);

const initialProductTechnologies = (
  ([__temp,__restore] = _withAsyncContext(() => pb.collection('product_technologies').getFullList<ProductTechnology>(null, {
  expand: 'technology',
  sort: 'technology.name',
  filter: `product.id = '${props.product.id}'`,
}))),
  __temp = await __temp,
  __restore(),
  __temp
);

const state: {
  saved: boolean,
  saving: boolean,
  savedProductTechnologies: ProductTechnology[],
  unsavedProductTechnologies: ProductTechnology[],
} = reactive({
  saved: false,
  saving: false,
  savedProductTechnologies: initialProductTechnologies,
  unsavedProductTechnologies: initialProductTechnologies,
});

function toggleTechnology(technology: Technology) {
  const productTechnology = state.unsavedProductTechnologies.find(pt => pt.technology === technology.id);

  if (productTechnology) {
    state.unsavedProductTechnologies = state.unsavedProductTechnologies.filter(pt => pt.technology !== technology.id);
  } else {
    const previouslySaved = state.savedProductTechnologies.find(pt => pt.technology === technology.id);

    state.unsavedProductTechnologies.push({
      id: previouslySaved?.id || '',
      product: props.product.id,
      technology: technology.id,
      version: previouslySaved?.version || '',
      comment: previouslySaved?.comment || '',
    });
  }
}

async function save() {
  state.saved = false;
  state.saving = true;

  const savedTechnologyIds = state.savedProductTechnologies.map(pt => pt.technology);
  const unsavedTechnologyIds = state.unsavedProductTechnologies.map(pt => pt.technology);
  const deselectedTechnologyIds = savedTechnologyIds.filter(id => !unsavedTechnologyIds.includes(id));

  for (const technologyId of deselectedTechnologyIds) {
    await pb.collection('product_technologies').delete(
        state.savedProductTechnologies.find(pt => pt.technology == technologyId)?.id
    );
  }

  const savedProductTechnologies = [];
  for (const productTechnology of state.unsavedProductTechnologies) {
    if (productTechnology.id === '') {
      savedProductTechnologies.push(await pb.collection('product_technologies').create<ProductTechnology>({
        product: productTechnology.product,
        technology: productTechnology.technology,
        version: productTechnology.version,
        comment: productTechnology.comment,
      }));
    } else {
      await pb.collection('product_technologies').update(productTechnology.id, {
        version: productTechnology.version,
        comment: productTechnology.comment,
      });
      savedProductTechnologies.push(productTechnology);
    }
  }

  state.saved = true;
  state.saving = false;
  state.savedProductTechnologies = savedProductTechnologies;
  state.unsavedProductTechnologies = savedProductTechnologies;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Dialog, {
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
    title: `Edit ${_ctx.product.name}`,
    description: "Change the technologies of the product"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Button, {
            label: "Save changes",
            outline: "",
            fill: "",
            class: "mb-4",
            loading: state.saving,
            disabled: state.saving,
            onClick: _withModifiers(save, ["prevent"])
          }, null, 8, ["loading", "disabled"]),
          (state.saved)
            ? (_openBlock(), _createBlock(Success, {
                key: 0,
                class: "mb-4"
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Saved!")
                ])),
                _: 1,
                __: [2]
              }))
            : _createCommentVNode("", true),
          _createVNode(Input, {
            modelValue: searchTerm.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
            label: "Search term",
            placeholder: "Search technology ...",
            marginless: ""
          }, null, 8, ["modelValue"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedTechnologies.value, (group) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            _createVNode(Heading, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(group.category), 1)
              ]),
              _: 2
            }, 1024),
            _createElementVNode("table", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(group.types), (subgroup) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[3] || (_cache[3] = _createElementVNode("th", { class: "w-8" }, null, -1)),
                      _createElementVNode("th", null, [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(subgroup.type), 1)
                      ]),
                      _cache[4] || (_cache[4] = _createElementVNode("th", { class: "w-24" }, "Version", -1)),
                      _cache[5] || (_cache[5] = _createElementVNode("th", null, "Comment", -1))
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subgroup.technologies, (technology) => {
                    return (_openBlock(), _createElementBlock("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([state.unsavedProductTechnologies.find(pt => pt.technology === technology.id)], (productTechnology) => {
                        return (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                          _createElementVNode("td", null, [
                            _createVNode(_unref(CheckCircleIcon), {
                              onClick: ($event: any) => (toggleTechnology(technology)),
                              class: _normalizeClass(['icon', productTechnology ? '' : 'opacity-20'])
                            }, null, 8, ["onClick", "class"])
                          ]),
                          _createElementVNode("td", {
                            class: _normalizeClass(['cursor-pointer', productTechnology ? '' : 'opacity-50']),
                            onClick: ($event: any) => (toggleTechnology(technology))
                          }, _toDisplayString(technology.name), 11, _hoisted_5),
                          productTechnology
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("td", null, [
                                  _createVNode(Input, {
                                    label: "Version",
                                    modelValue: productTechnology.version,
                                    "onUpdate:modelValue": ($event: any) => ((productTechnology.version) = $event),
                                    class: "text-xs",
                                    marginless: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(Input, {
                                    label: "Comment",
                                    modelValue: productTechnology.comment,
                                    "onUpdate:modelValue": ($event: any) => ((productTechnology.comment) = $event),
                                    class: "text-xs",
                                    marginless: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ])
                              ], 64))
                            : (_openBlock(), _createElementBlock("td", _hoisted_6))
                        ]))
                      }), 256))
                    ]))
                  }), 256))
                ], 64))
              }), 256))
            ])
          ], 64))
        }), 256))
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})